import { useEffect, useRef } from 'react'

import { Box, BoxProps } from '@mantine/core'
import { useInView } from 'react-intersection-observer'

type SectionWrapperProps = {
  onInView?: (v: boolean) => void
} & BoxProps

const SectionWrapper = ({
  children,
  onInView,
  ...props
}: SectionWrapperProps) => {
  const refOutside = useRef<HTMLDivElement | null>(null)
  const { ref, inView } = useInView({
    rootMargin: `-120px 0px 0px 0px`,
  })

  useEffect(() => {
    onInView?.(inView)
  }, [inView])

  return (
    <Box {...props} data-in-view={inView} ref={refOutside}>
      <Box ref={ref}>{children}</Box>
    </Box>
  )
}

export { SectionWrapper }
